import React from 'react';
import styles from "../../../styles/components/UI/Custom/LoadingCircle.module.css"

export const LoadingCircle = ({ size = 50, color = '#3498db', thickness = 5 }) => {
  return (
    <div className={styles.container}>

<div 
      className={styles.loader} 
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${thickness}px`,
        borderColor: `${color} transparent transparent transparent`
      }}
    ></div>
    </div>
  );
};

